import { getCollectionChangesFromPatchByOp } from "../history";
export const createImmerPatchAdapter = () => ({
    toDocumentCollectionChanges: (patch) => {
        // TODO: Can ignore paths other than pcbNodes and nets for now?
        return getCollectionChangesFromPatchByOp(patch, "forward");
    },
});
//# sourceMappingURL=ImmerPatchAdapter.js.map